import { DataTab, dataResources, type DataResource } from '@/pages/CarePlanView/DataTab';
import { LAB_RESULT_CATEGORIES } from '@liza/fhir-utils';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { z } from 'zod';

const DataSearchSchema = z.object({
  resource: z.enum(dataResources).default('conditions'),
  id: z.string().optional(),
  labIdentifier: z.string().optional(),
  /** The lab category whose level-2 view is open. */
  labGroup: z.enum(LAB_RESULT_CATEGORIES).optional(),
  vitalIdentifier: z.string().optional(),
  surveyIdentifier: z.string().optional(),
  medicationResourceType: z.enum(['MedicationRequest', 'MedicationStatement']).optional(),
});

const RouteComponent = (): React.ReactNode => {
  // oxlint-disable-next-line no-use-before-define
  const { patientId } = Route.useParams();
  const { resource, id, labIdentifier, labGroup, vitalIdentifier, surveyIdentifier, medicationResourceType } =
    // oxlint-disable-next-line no-use-before-define
    Route.useSearch();
  // oxlint-disable-next-line no-use-before-define
  const navigate = useNavigate({ from: Route.fullPath });

  return (
    <DataTab
      patientId={patientId}
      resource={resource}
      selectedId={id}
      labIdentifier={labIdentifier}
      labGroup={labGroup}
      vitalIdentifier={vitalIdentifier}
      surveyIdentifier={surveyIdentifier}
      medicationResourceType={medicationResourceType}
      onSelectResource={(next: DataResource) => {
        void navigate({ search: { resource: next } });
      }}
      onSelectItem={(opts) => {
        void navigate({
          search: {
            resource,
            id: opts.id,
            labIdentifier: opts.labIdentifier,
            labGroup: opts.labGroup,
            vitalIdentifier: opts.vitalIdentifier,
            surveyIdentifier: opts.surveyIdentifier,
            medicationResourceType: opts.medicationResourceType,
          },
        });
      }}
      onNavigateToResource={(opts) => {
        void navigate({
          search: { resource: opts.resource, id: opts.id, labIdentifier: opts.labIdentifier, labGroup: opts.labGroup },
        });
      }}
    />
  );
};

export const Route = createFileRoute('/_auth/care-plan/$patientId/data')({
  component: RouteComponent,
  validateSearch: DataSearchSchema,
});
